import script from "./PortalSurchargeTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PortalSurchargeTable.vue?vue&type=script&setup=true&lang=js"

import "./PortalSurchargeTable.vue?vue&type=style&index=0&id=473c64ec&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-473c64ec"]])

export default __exports__